import { createSlice } from "@reduxjs/toolkit";
import * as API from "@vantiva-sa/spmrestclient/dist";
import { AppStorageKeys } from "../Constants/Constants";
import SessionStorage from "../Constants/SessionStorage";
import { getCurrentUserFromStorage } from "../Constants/Utilities";

const ENV_VARS_FE = SessionStorage.get(AppStorageKeys.envVars);

const API_URL = ENV_VARS_FE.API_URL;
const API_PORT = ENV_VARS_FE.API_PORT;

const defaultClient = API.ApiClient.instance;
const headers = defaultClient.defaultHeaders;

const currentUser = getCurrentUserFromStorage();
if (currentUser && currentUser.access_token) {
  headers["Authorization"] = "Bearer " + currentUser.access_token;
}

const initialState = {
  serviceApi: new API.ServiceApi(),
  serviceProviderApi: new API.ServiceProviderApi(),
  serviceProviderGroupApi: new API.ServiceProviderGroupApi(),
  serviceDependencyApi: new API.ServiceDependencyApi(),
  serviceInstanceApi: new API.ServiceInstanceApi(),
  serviceOfferingApi: new API.ServiceOfferingApi(),
  serviceEntitlementApi: new API.ServiceEntitlementApi(),
  serviceTierApi: new API.ServiceTierApi(),
  deviceModelApi: new API.DeviceModelApi(),
  deviceApi: new API.DeviceApi(),
  groupApi: new API.GroupApi(),
  orderApi: new API.OrderApi(),
  deviceEntitlementApi: new API.DeviceEntitlementApi(),
  configManagementApi: new API.ConfigurationManagementApi(),
  deviceModelDependencyApi: new API.DeviceModelDependencyApi(),
};

const apiStore = createSlice({
  name: "apis",
  initialState,
  reducers: {
    setBaseURL: (state, action) => {
      const apiURL = API_URL || action.payload;
      defaultClient.basePath = apiURL + ":" + API_PORT;
      defaultClient.timeout = 1800000; // api request client timeout - 30 mins
    },
    setAccessToken: (state, action) => {
      headers["Authorization"] = "Bearer " + action.payload;
    },
  },
});

export const { setBaseURL, setAccessToken } = apiStore.actions;

export default apiStore.reducer;
